<app-organizer-shared-layout-dashboard [hasHeader]="hasHeader">
  <app-organizer-shared-header
    class="col-span-12 mb-4 lg:col-span-6 lg:mb-3"
    [title]="'organizer.timeslot.pre_schedule.plans.page.title' | translate"
    [backLink]="backLink"
    [backLinkAriaLabel]="
      'a11y.organizer.timeslot.pre_schedule.plans.page.title' | translate
    "
  ></app-organizer-shared-header>

  <div class="col-span-12 lg:col-span-5 lg:col-start-2">
    <app-tips
      *ngIf="formErrors?.length"
      class="block mb-2"
      [icon]="iconType.WarningError"
      [title]="'organizer.pre_schedule.form_error' | translate"
      [tips]="formErrors"
      [variant]="tipsVariant"
    >
    </app-tips>
    <form class="flex flex-col" (ngSubmit)="submit()">
      <app-organizer-shared-form-plans
        [formControl]="plans"
        [editionMode]="
          isBirthday ? formPlansEditionMode.FULL : formPlansEditionMode.LIGHT
        "
        [translationKeyPrefix]="
          isBirthday ? translationKeySubPath.BIRTHDAY : ''
        "
      >
      </app-organizer-shared-form-plans>
      <button
        app-vtmn-play-button
        type="submit"
        class="self-start w-full mt-4 md:w-auto"
        [type]="ctaButtonType.Submit"
        [disabled]="hasErrors ? true : null"
        [attr.data-disabled]="hasErrors ? true : null"
      >
        {{ 'organizer.edit_field.button.save' | translate }}
      </button>
    </form>
  </div>
</app-organizer-shared-layout-dashboard>
